<wl-aom-costs-per-unit
  [costPerUnitVM]="costPerUnitVM()"
  [rendering]="rendering()"
  [isVATIncluded]="isVATIncluded()"
  [fields]="fields()"
  [isDynamicProduct]="offer()?.isDynamicProduct"
/>
@if (fields()?.AomDynamicPricingDisclaimer && isDynamicProduct) {
  <div *wlGenericRichText="fields()?.AomDynamicPricingDisclaimer"></div>
}
<p class="h4 mt-3 text-black" wlCSCapture>
  {{
    monthlyBudgetPaymentHeading ||
      getFieldValue(fields(), 'BudgetBillAmountTitle')
  }}
</p>
<wl-rich-text-wrapper
  [field]="
    {
      value: enableRemoveBBA()?.valueOf()
        ? getFieldValue(fields(), 'NoBudgetBillAmountParagraph')
        : monthlyBudgetPaymentParagraph ||
          getFieldValue(fields(), 'BudgetBillAmountParagraph'),
    }
      | interpolate
        : {
            mode: 'rich_text',
            variables: {
              kwhNormal: kwhNormal,
              kwhLow: kwhLow,
              gas: gas,
              budgetBillAmount: budgetBillAmount | roundedCurrency,
            },
          }
  "
>
  <p class="section-content" wlCSCapture></p>
</wl-rich-text-wrapper>

@if (hasDiscount) {
  <p
    wlCSCapture
    class="h4 mt-3 text-black"
    *scText="
      fields()?.CashbackTitle
        | interpolate
          : {
              variables: {
                cashback:
                  offer()?.discountPrice | currency: 'EUR' : 'symbol' : '1.2',
              },
            }
    "
  ></p>
  <p class="section-content">
    <span *scText="fields()?.CashbackParagraphPart1" wlCSCapture></span>
    <span class="text-green fw-bold ms-1" wlCSCapture>{{
      fields()?.CashbackParagraphPart2?.value + '.'
        | interpolate
          : {
              variables: {
                cashback:
                  offer()?.discountPrice | currency: 'EUR' : 'symbol' : '1.2',
              },
            }
    }}</span>
    <br />
    <span *scText="fields()?.CashbackParagraphPart3" wlCSCapture></span>
  </p>
} @else {
  @if (offer()?.incentiveFullDescription) {
    <p class="h4 mt-3 text-black">
      <span *scText="fields()?.IncentiveTitlePrefix" wlCSCapture></span>
      {{ offer()?.incentiveTitle }}
    </p>
    <p
      wlCSCapture
      class="section-content"
      [innerHtml]="
        fields()?.IncentiveBodyPrefix?.value +
        ' ' +
        offer()?.incentiveFullDescription
      "
    ></p>
  }
}
<ng-template #description>
  @if (offer()?.incentiveFullDescription) {
    <p class="h4 mt-3 text-black">
      <span *scText="fields()?.IncentiveTitlePrefix" wlCSCapture></span>
      {{ offer()?.incentiveTitle }}
    </p>
    <p
      wlCSCapture
      class="section-content"
      [innerHtml]="
        fields()?.IncentiveBodyPrefix?.value +
        ' ' +
        offer()?.incentiveFullDescription
      "
    ></p>
  }
</ng-template>

<p class="h4 mt-3 text-black" *scText="fields()?.AomOfferTitle" wlCSCapture></p>
<div class="section-content">
  @if (!kwhLow) {
    @if (isVATIncluded) {
      <ng-container>
        <wl-rich-text-wrapper
          wlAutomationId="aom-paragraph-single"
          [field]="
            fields()?.AomOfferParagraph
              | interpolate
                : {
                    mode: 'rich_text',
                    variables: {
                      kwh: kwhNormal,
                      gas: gas,
                      solarReturn: solarReturn,
                    },
                  }
          "
        >
          <p></p>
        </wl-rich-text-wrapper>
      </ng-container>
    } @else {
      <ng-container>
        <wl-rich-text-wrapper
          wlAutomationId="aom-paragraph-single"
          [field]="
            fields()?.AomOfferParagraphExcludingVat
              | interpolate
                : {
                    mode: 'rich_text',
                    variables: {
                      kwh: kwhNormal,
                      gas: gas,
                      solarReturn: solarReturn,
                    },
                  }
          "
        >
          <p></p>
        </wl-rich-text-wrapper>
      </ng-container>
    }
  } @else {
    @if (isVATIncluded()) {
      <ng-container>
        <wl-rich-text-wrapper
          wlAutomationId="aom-paragraph-double"
          [field]="
            fields()?.AomOfferParagraphDoubleMeter
              | interpolate
                : {
                    mode: 'rich_text',
                    variables: {
                      kwhNormal: kwhNormal,
                      kwhLow: kwhLow,
                      gas: gas,
                      solarReturn: solarReturn,
                      solarReturnLow: solarReturnLow,
                    },
                  }
          "
        >
          <p class="mb-3"></p>
        </wl-rich-text-wrapper>
      </ng-container>
    } @else {
      <ng-container>
        <wl-rich-text-wrapper
          wlAutomationId="aom-paragraph-double"
          [field]="
            fields()?.AomOfferParagraphDoubleMeterExcludingVat
              | interpolate
                : {
                    mode: 'rich_text',
                    variables: {
                      kwhNormal: kwhNormal,
                      kwhLow: kwhLow,
                      gas: gas,
                      solarReturn: solarReturn,
                      solarReturnLow: solarReturnLow,
                    },
                  }
          "
        >
          <p class="mb-3"></p>
        </wl-rich-text-wrapper>
      </ng-container>
    }
  }
</div>

<wl-aom-cost-table
  [rendering]="rendering()"
  [offer]="offer()"
  [fields]="fields()"
  [enableRemoveBBA]="enableRemoveBBA()"
  [hasDiscount]="hasDiscount"
/>

@if (disclaimer !== '') {
  <wl-disclaimer [disclaimer]="disclaimer" />
}
